"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceUnavailableModal = void 0;
const React = require("react");
const dialogs_1 = require("../../../../../types/dialogs");
const Modal_1 = require("../../../../../components/base/structure/Modal");
const Button_1 = require("../../../../../components/base/atoms/Button");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ServiceUnavailableModal");
const ServiceUnavailableModal = ({ serviceUnavailableMsg, setServiceUnavailableMsg }) => {
    return (React.createElement(Modal_1.Modal, { open: !!serviceUnavailableMsg, size: dialogs_1.TDialogSizes.Medium, onClose: null },
        React.createElement(Modal_1.ModalBody, null,
            React.createElement("div", { className: css("") },
                React.createElement("p", { className: css("serviceMsg") }, serviceUnavailableMsg))),
        React.createElement(Modal_1.ModalFooter, null,
            React.createElement(Button_1.BlockButton, { onClick: () => {
                    setServiceUnavailableMsg(null);
                } }, "ok"))));
};
exports.ServiceUnavailableModal = ServiceUnavailableModal;
//# sourceMappingURL=index.js.map